<div class="flex items-center justify-between w-full gap-4">
  <h1 *ngIf="data.showLabel">
    Edit Templates
  </h1>
  <div class="w-1/2 min-w-[600px] max-w-lg">
    <form [formGroup]="form" class="w-full">
      <mat-form-field appearance="outline" class="w-full !p-0">
        <mat-icon matPrefix class="text-darkGray opacity-70">search</mat-icon>
        <input
          [formControl]="form.controls.searchText"
          matInput
          placeholder="Search template name">
        <button
          type="button"
          [disabled]="(loading$|async)"
          *ngIf="form.value.searchText"
          (click)="resetForm($event)"
          matSuffix
          mat-icon-button>
          <mat-icon matSuffix class="text-darkGray opacity-70">backspace</mat-icon>
        </button>
      </mat-form-field>
    </form>
  </div>

  <button
    mat-raised-button color="primary"
    *ngIf="data.showGenerateDocumentBtn"
    appConfirmDialog
    (ok)="generateAllTemplates()">Generate all templates
    <mat-icon svgIcon="generate_document" class="custom-icon-white"></mat-icon>
  </button>
</div>


<div class="document-template-table-container">
  <div class="table-container mat-elevation-z1" *ngrxLet="items$ as dataSource">
    <table mat-table [dataSource]="dataSource" class="table-custom">
      <ng-container matColumnDef="name">
        <th mat-header-cell class="!text-white" *matHeaderCellDef> Name</th>
        <td mat-cell *matCellDef="let element" class="truncate" [matTooltip]="element.name"> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell class="!text-white !text-center" *matHeaderCellDef> Status</th>
        <td mat-cell *matCellDef="let element" class="truncate">
          <app-status class="block !text-sm"
                      [statusMessage]="element.status"
                      [statusStyle]="element.statusColor()"
                      fontWeight="semibold">
          </app-status>
        </td>
      </ng-container>

      <ng-container matColumnDef="frequencyOfGeneration">
        <th mat-header-cell class="!text-white w-3/12" *matHeaderCellDef> Frequency of Generation
          <mat-icon
            class="align-middle"
            (mouseenter)="onMouseEnter($event)"
            (mouseleave)="onMouseLeave()"
            #triggerEl
          >info</mat-icon>

          <ng-template #infoTpl>
            <div class="text-sm px-2 py-2 text-white rounded max-w-[400px]" style="background-color: rgba(0, 0, 0, 0.8)">
              <p>Frequency of generation defines how many times a specific template should be generated based on the structure and attributes of a given entity. It determines the number of forms to produce according to the roles or components involved in that entity.</p>
              <p>Typical frequencies include:</p>
              <div class="pl-4">
                <ul>
                  <li>
                    By entity: Generate one form for the entire entity;.
                  </li>
                  <li>
                    Per director: Generate one or more forms for each listed director
                  </li>
                  <li>
                    Per shareholder: Generate one or more forms for each listed shareholder.
                  </li>
                  <li>
                    Per secretary: Generate one or more forms for each listed secretary.
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
        </th>
        <td mat-cell *matCellDef="let element" class="truncate">{{ element.documentTemplateType?.frequencyOfGeneration }} </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell
            *matHeaderCellDef
            class="!text-center !text-white">Last update
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="text-center">
          {{element.updatedAt | date }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell class="!text-white" *matHeaderCellDef> Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="flex gap-2">
<!--            <button mat-icon-button color="primary" [matTooltip]="'View Template With Highlights'" (click)="view(element, true)">-->
<!--              <mat-icon svgIcon="view_document" class="custom-icon-green"></mat-icon>-->
<!--            </button>-->
            <button mat-icon-button color="primary" [matTooltip]="'Review Template'" (click)="view(element, true)">
              <mat-icon svgIcon="view_document" class="custom-icon-primary"></mat-icon>
            </button>
            <button *ngIf="data.showGenerateDocumentBtn" mat-icon-button color="primary" [matTooltip]="'Generate Document'" appConfirmDialog (ok)="generateDocument(element)">
              <mat-icon svgIcon="generate_document" class="custom-icon-primary"></mat-icon>
            </button>
            <button mat-icon-button color="primary" *ngIf="data.showDownload" [matTooltip]="'Download Template'" (click)="download(element)">
              <mat-icon svgIcon="download_document" class="custom-icon-primary"></mat-icon>
            </button>
            <button mat-icon-button color="primary" *ngIf="data.showUpdate" [matTooltip]="'Update Template'" (click)="update(element)">
              <mat-icon svgIcon="upload_document" class="custom-icon-primary"></mat-icon>
            </button>
<!--            <button mat-icon-button color="warn" (ok)="delete(element)" appConfirmDialog>-->
<!--              <mat-icon>delete</mat-icon>-->
<!--            </button>-->
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-primary-800 text-white"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="data-row"></tr>
      <tr class="mat-row"
          *matNoDataRow>
        <td [colSpan]="displayedColumns.length">
          <app-table-loading *ngIf="(loading$ | async); else noRecord"></app-table-loading>
          <ng-template #noRecord>
            <table-no-record [notFoundMessage]="'No templates'"></table-no-record>
          </ng-template>
        </td>
      </tr>
    </table>

    <ng-container *ngIf="data$ | async as data">
      <mat-paginator
        (page)="onPageChanged($event)"
        [length]="data.total ?? 0"
        [pageIndex]="data.currentPage ? data.currentPage - 1 : 0"
        [pageSize]="data.perPage ?? 10"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons>
      </mat-paginator>
    </ng-container>
  </div>
</div>
